export const TEST_ID = 'lifecycleControl';
